// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Mgpb","consentsList":"PatientConsents_consentsList__svf0q","consentsListEmpty":"PatientConsents_consentsListEmpty__3PQfV"};